// removed by extract-text-webpack-plugin
module.exports = {"Button":"_3zMFb","ButtonDotsContainer":"_1DYDn","ButtonDots":"_1V9G-","Dropdown":"_2XeK5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DropdownMenu/DropdownMenu.scss
// module id = 533
// module chunks = 0